<template>
  <div class="side-nav">
    <div
      v-for="root in rootItems"
      :key="root.id"
      class="category"
    >
      <a
        :href="root.url"
        @click="onClickLink([root.name])"
      >
        {{ root.name }}
      </a>
      <ul
        v-for="item in (root.items || []).reduce((acc, items) => [...acc, ...items], [])"
        :key="item.id"
        :class="['subcategory', {active: item.url === activeCategory}]"
      >
        <a
          :href="item.url"
          @click="onClickLink([root.name, item.name])"
        >
          {{ item.name }}
        </a>
        <li v-if="activeCategory && activeCategory.includes(item.url) && item.items.length">
          <div
            v-for="sub in (item.items || []).reduce((acc, items) => [...acc, ...items], [])"
            :key="sub.id"
            :class="{active: sub.url === activeCategory}"
          >
            <a
              :href="sub.url"
              @click="onClickLink([root.name, item.name, sub.name])"
            >
              {{ sub.name }}
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { catalogGtmEvents } from '@/gtm/catalog-gtm-events';

export default {
  name: 'side-nav',

  data() {
    return {
      activeCategory: this.$route.path
    }
  },

  computed: {
    ...mapGetters({
      MENU: 'menu/categoryMenu',
      BREADCRUMBS: 'breadcrumbs/getBreadCrumbs',
    }),
    rootItems() {
      // трешово конечно
      return this.MENU[0]?.[0]?.items?.[0] || [];
    },
    rootName() {
      return this.MENU[0]?.[0]?.name || '';
    },
  },
  methods: {
    ...mapActions({
      LOAD: 'menu/loadCategoryMenu'
    }),

    onClickLink(newPath) {
      catalogGtmEvents.clickMenuItem({
        oldPath: this.BREADCRUMBS.map(({ name }) => name),
        newPath: [this.rootName, ...newPath],
      });
    },
  },
  serverPrefetch() {
    return this.LOAD();
  }
};
</script>

<style lang="scss">
.side-nav {
  display: none;
}

@include breakpoint("desktop") {
  .side-nav {
    display: block;
    width: 184px;
    min-width: 184px;
    margin-right: 24px;
    flex-basis: 184px;
    .category {
      margin-top: 24px;
      font-size: 16px;
      line-height: 20px;
      color: $black;
      font-weight: 600;

      &:first-of-type {
        margin-top: 32px;
      }
    }

    .subcategory {
      margin-top: 16px;
      font-size: 14px;
      font-weight: normal;

      &.active {
        & > a {
          position: relative;
          font-weight: 600;
        }

        & > a::before {
          content: '';
          position: absolute;
          left: -14px;
          display: block;
          width: 2px;
          height: 100%;
          background-color: $black;
        }
      }

      & > li {
        & > div {
          margin-top: 8px;
          padding-left: 14px;
        }

        & > div.active {
          border-left: 2px solid $black;
        }
      }
    }
  }
}
</style>
